<template>
  <div class="home">
    <div class="home_container flex">
      <div class="identity_message">
        <!-- 身份选择-->
        <div class="choice identity_choice">
          <div class="choice_title">
              当前是什么状态
          </div>
          <div class="choice_tips">
              选择状态，推荐最适合的简历模板~（可多选）
          </div>
          <div class="state_content">
            <div @click="selectState(index)" class="state_content_item" v-for="(item, index) in itemList" :key="index">
              <img :src="item.url" alt="">
              <span>{{item.value}}</span>
              <i v-show="item.selected" class="iconfont iconxuanzhong selected"></i>
            </div>
          </div>
          <div class="identity_content_bottom">
            <div @click="next" :class="{disable : !enableNext}">下一步</div>
            <div @click="pre">上一步</div>
          </div>
        </div>
        
      </div>
    </div>
  </div>  
</template>

<script>
import api from '@/api';
import { get_tUser, routerTo } from '../../assets/js/util';
export default {
  name:'state',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      window.history.replaceState(null,null,`/jobs/state?identity=${vm.$route.query.identity}`)
    })
  },
  created(){
    this.identity = this.$route.query.identity
    api.identity.getOnboardingState({status: this.identity}).then(res => {
      if(res.code == 1000) {
        this.itemList = res.data
        this.itemList.forEach(item => {
          item.selected = false
        })
      }
    })
  },
  data(){
   return {
     itemList: [],
     selected: [], // 被选中的状态
     enableNext: false, // 能否下一页
     _c_t: '',
     identity: ''
   }
  },
  methods:{
    selectState(index) { // 选择状态
      this.itemList[index].selected = !this.itemList[index].selected
      this.itemList = JSON.parse(JSON.stringify(this.itemList))
      this.enableNext = this.itemList.filter(item => item.selected).length > 0
    },
    next() { 
      if(this.enableNext) {
        this._c_t = get_tUser().c_t;
        // 过滤出选择状态的数组
        this.selected = this.itemList.filter(item => {
          return item.selected
        }).map(item => {
          return item.key
        })
        api.me.updateUserIntention(this._c_t, {job_status: this.selected}).then(res => {
          if(res.code == 1000) {
            let toCvs = false
            // 学生选择状态中包含了 key为 0，1，5 的就去求职意向页否则去cvs
            if(this.identity == 'student') {
              toCvs = this.selected.findIndex(item => [0,1,5].includes(item)) == -1
            } else {
              toCvs = this.selected.findIndex(item => [0,1,3].includes(item)) == -1
            }
            if( toCvs ) {
              routerTo(`/cvs`)
            } else {
              routerTo(`/jobs/intention`)
            }   
          }
        }).catch(e => {
          console.log(e);
        })
      } else {
        this.$message({ 
          type:'warning',
          message:'请选择一个状态'
        })
      }
    },
    pre () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './jobs_intention.scss';
  .identity_message{
    position: relative;
  }
  .disable{
    color: #BCBCBC !important;
    background-color: #F4F4F4 !important;
  }
  .identity_content_bottom{
    // position: absolute;
    bottom: 32px;
    right: 56px;
  }
  .selected{
    position: absolute;
    top: 28px;
    right: 20px;
    color: #FF6644;
  }
  .state_content{
    width: 416px;
    margin: 54px auto 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .state_content_item{
      width: 200px;
      height: 72px;
      background-color: #FFFFFF;
      box-shadow: 0px 1px 12px 0px rgba(5, 32, 82, 0.06);
      border-radius: 8px;
      margin-bottom: 16px;
      position: relative;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #404040;
      cursor: pointer;
      &:hover{
        box-shadow: 0px 1px 24px 0px rgba(5, 32, 82, 0.1);
      }
      &>img{
        width: 32px;
        height: 32px;
        display: inline-block;
        margin-left: 36px;
        margin-right: 16px;
      }
    }
 }
</style>